import Vue from 'vue';
//import Vuetify from 'vuetify';
//import 'vuetify/dist/vuetify.min.css';
import Vuetify, {
    VApp,
    VMain,
    VContainer,
    VToolbar,
    VFooter,
    VSpacer,
    VDivider,
    VBtn,
    VIcon,
    VImg,
    VTooltip,
    VExpandTransition,
    VCard,
    VCardTitle,
    VCardSubtitle,
    VCardText,
    VCardActions,
    VSimpleTable,
    VRow,
    VCol
} from 'vuetify/lib'
Vue.use(Vuetify, {
    components: {
        VApp,
        VMain,
        VContainer,
        VToolbar,
        VFooter,
        VSpacer,
        VDivider,
        VBtn,
        VIcon,
        VImg,
        VTooltip,
        VExpandTransition,
        VCard,
        VCardTitle,
        VCardSubtitle,
        VCardText,
        VCardActions,
        VSimpleTable,
        VRow,
        VCol
    },
})

export default new Vuetify({
    icons: {
        iconfont: 'fa',
    },
});